export class PhotosCountersModel {
  constructor(public nbrOfPhotos: number,
              public nbrOfRefs: number,
              public storageSize: number) {}
}
